document.addEventListener("DOMContentLoaded", function () {
  const isDesktop = window.matchMedia("(min-width: 1025px)").matches;

  document.querySelectorAll(".slideshow__slide-inner").forEach((slideInner) => {
    const slideContainer = slideInner.closest(".slideshow__slide");
    const videoWrapper = slideContainer.querySelector(".slideshow__slide-video-bg");
    const video = videoWrapper?.querySelector("video");
    const controls = slideInner.querySelector(".slideshow-video-controls");

    if (!video || !controls) return;

    const playIcon = controls.querySelector(".icon-play");
    const pauseIcon = controls.querySelector(".icon-pause");
    const muteIcon = controls.querySelector(".icon-mute");
    const unmuteIcon = controls.querySelector(".icon-unmute");

    // Initial icon states
    playIcon.classList.remove("visible");
    pauseIcon.classList.add("visible");

    if (video.muted) {
      muteIcon.classList.add("visible");
      unmuteIcon.classList.remove("visible");
    } else {
      muteIcon.classList.remove("visible");
      unmuteIcon.classList.add("visible");
    }

    // Show controls (always visible)
    controls.style.opacity = "1";
    controls.style.visibility = "visible";

    // --- Play/Pause toggle ---
    controls.querySelector(".video-toggle-play").addEventListener("click", () => {
      if (video.paused) {
        video.play();
        playIcon.classList.remove("visible");
        pauseIcon.classList.add("visible");
      } else {
        video.pause();
        playIcon.classList.add("visible");
        pauseIcon.classList.remove("visible");
      }
    });

    // --- Mute/Unmute toggle ---
    controls.querySelector(".video-toggle-mute").addEventListener("click", () => {
      video.muted = !video.muted;
      if (video.muted) {
        muteIcon.classList.add("visible");
        unmuteIcon.classList.remove("visible");
      } else {
        muteIcon.classList.remove("visible");
        unmuteIcon.classList.add("visible");
      }
    });
  });
});